// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__HgINS","productName":"Table_productName__35VOp"};